var layout_default = {
  "layoutWrapper": "iXSfl",
  "layout": "DQcTd",
  "mobile": "ej4oc",
  "cell": "HbAle"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
